import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { Routes } from "../../routes";
import { useParams } from "react-router-dom";

import CheckPermissions from '../../components/multitools/CheckPermissions'

const Component = () => {
    let { _id } = useParams();
    // this component requirements
    const [componentId] = useState(`AddEarningSettingsActionButton_${Date.now()}`);
    const requirements = {
        componentId,
        auth: true,
        endpoints: [
            { method: 'POST', path: '/earning-settings-actions' },
        ]
    }

    return (   
      <CheckPermissions requirements={requirements} childrenIfNoPermission={null}>
        <Button variant="primary" size="sm" as={Link} to={Routes.AddEarningSettingsAction.path.replace(':_settingId', _id)}>
          <FontAwesomeIcon icon={faPlus} className="me-2" /> Add
        </Button>
      </CheckPermissions>
    );
};

export default Component;
